/* @flow */

import type { SettingValue } from './types';

import { Setting } from './types';

/*
 * See Shaka Player doc for information about the 3 following values:
 * https://shaka-player-demo.appspot.com/docs/api/tutorial-network-and-buffering-config.html
 */

// The amount of content attempted to be buffered (in s)
const DefaultBufferingGoal = 60;

// The minimum amount of content required to start playing (in s)
const DefaultRebufferingGoal = 2;

// The amount of content kept in buffer behind the playhead (in s)
const DefaultBufferBehind = 30;

export const getDefaultValueFromSetting = (name: Setting): SettingValue => {
  switch (name) {
    case Setting.AutoOpenPlayerDebugPanel:
      // By default, player debug panel is not automatically reopened if it was open the last time the player exited
      return false;
    case Setting.AutoPlayNextEpisode:
      // By default, the next episode is not automatically played
      return false;
    case Setting.AutoResume:
      // By default, if a viewing history exists, the player resumes to the last position without prompting the user
      return true;
    case Setting.AutoSelectAudioTrack:
      // By default, the player automatically tries to select the last audio track selected by the user
      return true;
    case Setting.AutoSelectSubtitlesTrack:
      // By default, the player automatically tries to select the last subtitles track selected by the user
      return true;
    case Setting.BufferBehind:
      // By default, the buffer behind is set to 30s (see at the top of this file)
      return DefaultBufferBehind;
    case Setting.BufferingGoal:
      // By default, the buffering goal is set to 60s (see at the top of this file)
      return DefaultBufferingGoal;
    case Setting.RebufferingGoal:
      // By default, the rebuffering goal is set to 2s (see at the top of this file)
      return DefaultRebufferingGoal;
    case Setting.GreenStreaming:
      // By default, green streaming is disabled
      return false;
    case Setting.LastAudioTrack:
      // By default, there is no last audio track
      return '';
    case Setting.LastSubtitlesTrack:
      // By default, there is no last subtitles track
      return '';
    case Setting.ParentalControlToggle:
      // By default, parental control is enabled
      return true;
    case Setting.PurchaseLockToggle:
      // By default, purchase lock is disabled
      return false;
    case Setting.Volume:
      // By default, the volume is 100%
      return 1;
  }
};
